/**
 * Main Page Links - AlpineJS 组件
 * 功能：
 * 1. 按钮切换功能（links-buttona / links-buttonb）
 * 2. YouTube 视频显示/隐藏功能
 */
document.addEventListener('alpine:init', () => {
  Alpine.data('pageLinks', () => ({
    // 当前激活的标签页：'a' 或 'b'
    activeTab: 'a',
    
    // YouTube 视频相关状态
    youtubeOpen: false,
    youtubeHeight: '0px',
    youtubeIframeLoaded: false,
    
    // YouTube 视频配置
    youtubeVideoId: 'pv8c2O5kFg0?si=jxLcoXkR17_80Ki7',
    
    /**
     * 切换到标签页 A
     */
    switchToTabA() {
      this.activeTab = 'a';
    },
    
    /**
     * 切换到标签页 B
     */
    switchToTabB() {
      this.activeTab = 'b';
    },
    
    /**
     * 检查是否显示 links-ass 内容
     */
    get showLinksAss() {
      return this.activeTab === 'a';
    },
    
    /**
     * 检查按钮B是否被点击（用于添加CSS类）
     */
    get isButtonBClicked() {
      return this.activeTab === 'b';
    },
    
    /**
     * 打开 YouTube 视频
     */
    openYouTube() {
      // 设置打开状态
      this.youtubeOpen = true;
      
      // 首次加载时标记 iframe 需要加载
      if (!this.youtubeIframeLoaded) {
        this.youtubeIframeLoaded = true;
      }
      
      // 使用 $nextTick 确保 DOM 更新后再设置高度
      this.$nextTick(() => {
        // 触发重排
        const container = this.$refs.youtubeContainer;
        if (container) {
          // 先设置为 0 以触发重排
          this.youtubeHeight = '0px';
          container.offsetHeight;
          // 然后设置目标高度以触发过渡动画
          this.youtubeHeight = '315px';
        }
      });
    },
    
    /**
     * 关闭 YouTube 视频
     */
    closeYouTube() {
      // 开始关闭动画
      this.youtubeHeight = '60px';
      
      // 等待过渡动画完成
      this.$nextTick(() => {
        const container = this.$refs.youtubeContainer;
        if (container) {
          const handleTransitionEnd = () => {
            // 重置状态
            this.youtubeOpen = false;
            this.youtubeHeight = '0px';
            this.youtubeIframeLoaded = false;
            container.removeEventListener('transitionend', handleTransitionEnd);
          };
          
          container.addEventListener('transitionend', handleTransitionEnd, { once: true });
        }
      });
    },
    
    /**
     * 获取 YouTube iframe 的完整 URL
     */
    get youtubeIframeSrc() {
      return `https://www.youtube.com/embed/${this.youtubeVideoId}`;
    }
  }));
});
